<div class="table-bar">
  @if (selectable()) {
    <mat-checkbox
      class="table-bar__select-all"
      [checked]="allSelected()"
      [indeterminate]="someSelected()"
      [aria-label]="allSelected() ? 'Fravælg alle' : 'Vælg alle'"
      (change)="selectAll.emit($event.checked)"
    />
  }

  <span class="table-bar__count" role="status">{{ countText() }}</span>
  <ng-content select="[abookTableSummary]" />

  @if (selectedCount() > 0) {
    <div class="table-bar__bulk" role="group" aria-label="Handlinger for de valgte">
      <ng-content select="[abookBulkActions]" />
    </div>
  }

  <span class="table-bar__spacer"></span>

  @if (showResultFilter()) {
    <abook-filter-search
      class="table-bar__result-filter"
      icon="filter_list"
      compact
      [debounceMs]="200"
      [placeholder]="resultFilterPlaceholder()"
      ariaLabel="Filtrér de viste rækker"
      [value]="resultFilter() ?? ''"
      (valueChange)="resultFilterChange.emit($event)"
    />
  }

  @if (folded()) {
    @if (columns() || exportFormats().length) {
      <button
        mat-icon-button
        type="button"
        [matMenuTriggerFor]="foldedMenu"
        aria-label="Visning og eksport"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #foldedMenu="matMenu" xPosition="before">
        @if (columns()) {
          <button mat-menu-item [matMenuTriggerFor]="columnsMenu">
            <mat-icon>view_column</mat-icon>
            <span>{{ columnsText() }}</span>
          </button>
        }
        @for (format of exportFormats(); track format) {
          <button mat-menu-item (click)="exported.emit(format)">
            <mat-icon>download</mat-icon>
            <span>Eksportér som {{ exportLabels[format] }}</span>
          </button>
        }
      </mat-menu>
    }
  } @else {
    @if (columns()) {
      <button mat-button type="button" [matMenuTriggerFor]="columnsMenu">
        <mat-icon>view_column</mat-icon>
        {{ columnsText() }}
      </button>
    }
    @if (exportFormats().length) {
      <button mat-button type="button" [matMenuTriggerFor]="exportMenu">
        <mat-icon>download</mat-icon>
        Eksportér
      </button>
      <mat-menu #exportMenu="matMenu" xPosition="before">
        @for (format of exportFormats(); track format) {
          <button mat-menu-item (click)="exported.emit(format)">{{ exportLabels[format] }}</button>
        }
      </mat-menu>
    }
  }
</div>

<mat-menu #columnsMenu="matMenu" class="abook-filter-menu" xPosition="before">
  <div class="abook-filter-menu__heading" role="presentation">Viste kolonner</div>
  @for (column of availableColumns(); track column.value) {
    <button
      mat-menu-item
      role="menuitemcheckbox"
      [attr.aria-checked]="isShown(column.value)"
      [disabled]="isShown(column.value) && columns()!.displayed().length === 1"
      (click)="$event.stopPropagation(); columns()!.toggle(column.value)"
    >
      <mat-pseudo-checkbox [state]="isShown(column.value) ? 'checked' : 'unchecked'" />
      <span>{{ column.label }}</span>
    </button>
  }
  <div class="abook-filter-menu__footer">
    <button
      mat-menu-item
      [disabled]="$safeNavigationMigration(columns()?.isDefault())"
      (click)="$event.stopPropagation(); columns()!.restoreDefault()"
    >
      <mat-icon>restart_alt</mat-icon>
      <span>Gendan standard</span>
    </button>
    @if (pageName()) {
      <div class="abook-filter-menu__note">Huskes for {{ pageName() }} på denne computer</div>
    }
  </div>
</mat-menu>
